import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { environment } from './environment';

// Initialize Firebase
const app = initializeApp(environment.firebase);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;
